import React, {Component} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import TourWorkLayout from '../modules/TourWork'
import Rist from '../../Rist'
import NotFound from '../modules/NotFound'

class TourWork extends Component {
  render () {
    if (!(this.props.id > 0 && this.props.id < this.props.items.length + 1)) {
      return (
        <Rist><NotFound/></Rist>
      )
    }
    return (
      <TourWorkLayout tourWork={this.props.items[this.props.id-1]} logo={this.props.logo} menu={this.props.menu} id={this.props.id}/>
    )
  }
}

export default withRouter(connect(
 (state, props) => ({
   logo: state.rist.content.logo,
   menu: state.rist.content.menu,
   items: state.rist.content.tour.items,
   id: props.match.params.id,
   history: props.history,
 })
)(TourWork))



// WEBPACK FOOTER //
// ./src/Rist/containers/TourWork.js